
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"29","viewBox":"0 0 34 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.905 11.985h-8.5a.662.662 0 01-.66-.661V4.89c0-.365.296-.661.66-.661h8.5c.365 0 .66.296.66.66v6.435a.66.66 0 01-.66.661zm-7.838-1.322h7.176V5.55H6.067v5.112zM28.047 11.985h-8.5a.662.662 0 01-.66-.661V4.89c0-.365.295-.661.66-.661h8.5c.364 0 .66.296.66.66v6.435a.66.66 0 01-.66.661zm-7.839-1.322h7.177V5.55h-7.177v5.112zM8.355 13.342H7.032v10.614h1.323V13.342z"}}),_c('path',{attrs:{"d":"M9.972 14.227H5.406v1.322h4.566v-1.322zM14.463 13.342h-1.322v10.614h1.322V13.342z"}}),_c('path',{attrs:{"d":"M16.08 17.988h-4.566v1.323h4.567v-1.323zM20.544 13.342H19.22v10.614h1.323V13.342z"}}),_c('path',{attrs:{"d":"M22.162 13.34h-4.567v1.322h4.567V13.34zM26.546 13.342h-1.322v10.614h1.322V13.342z"}}),_c('path',{attrs:{"d":"M28.164 20.398h-4.567v1.323h4.567v-1.323z"}}),_c('path',{attrs:{"d":"M27.263 1.869a4.321 4.321 0 014.321 4.32v15.806a4.321 4.321 0 01-4.321 4.322H6.189a4.321 4.321 0 01-4.321-4.322V6.19a4.321 4.321 0 014.32-4.321h21.075zm0-1.869H6.189A6.195 6.195 0 000 6.189v15.805a6.195 6.195 0 006.189 6.19h21.074a6.195 6.195 0 006.189-6.19V6.19A6.196 6.196 0 0027.263 0z"}})])
          )
        }
      }
    